<script>
	import Client from 'shopify-buy/index.unoptimized.umd';
	import { onMount } from 'svelte';
	import BuilderCollectionSection from './components/BuilderCollectionSection.svelte'
	import BuilderSection from './components/BuilderSection.svelte'
	import '../node_modules/bulma/css/bulma.min.css';
	import {clickOutside} from './utils/clickOutside.js';


	/*
		Each collection is it's own step in the builder wizard.
		const builderCollectionIds = [
			278689546403, // Kokoa omat juhlat - vaihe 1 | Pakettien valinta
			278689677475, // Kokoa omat juhlat - vaihe 2 | Lisäpalvelut
		];
	*/
	let checkout = false;
	let checkoutProcessing = false;
	let checkoutNotes = false;
	let builderCollections = false;
	let builderProducts = false;
	let _builderCollections = false;
	let _builderProducts = false;
	let currentStep = 1;
	let priceTotal = 0;
	let currentSelection = []; // array of selected products
	let selectedHandles = []; // array of selected products handles
	
	let modal = {
		open: false,
		title: '',
		content: ''
	}

	const clientOptions = {
		domain: 'jcstore-fi.myshopify.com',
		storefrontAccessToken: 'ff9b2a3a625659d4d2c8d14240082b0e'
	};

	const client = Client.buildClient(clientOptions);

	onMount(async () => {

		_builderCollections = await client.collection.fetchAllWithProducts();
		_builderProducts = await client.product.fetchAll(250);

		// convert each builderCollections from GraphModel to plain object, and  convert from
		// as well as field values from Scalar to plain value
		builderCollections = _builderCollections.map(collection => {
			const plainCollection = collection.attrs
			const plainProducts = plainCollection.products.map(product => product.attrs);
			plainCollection.products = plainProducts;

			for (const [key, value] of Object.entries(plainCollection)) {
				if (value?.value) {
					plainCollection[key] = value.value;
				}
			}
			return plainCollection;
		});

		// convert each builderProducts from GraphModel to plain object, and  convert from
		// as well as field values from Scalar to plain value
		builderProducts = _builderProducts.map(product => {
			const plainProduct = product.attrs

			// same for variants
			const plainVariants = plainProduct.variants.map(variant => variant.attrs);
			plainProduct.variants = plainVariants;

			for (const [key, value] of Object.entries(plainProduct)) {
				if (value?.value) {
					plainProduct[key] = value.value;
				}
			}

			for (let variant of plainProduct.variants) {
				for (const [key, value] of Object.entries(variant)) {
					if (value?.value) {
						variant[key] = value.value;
					}
				}
			}

			

			return plainProduct;
		});

		// get collections with products using graphQL client

		/* const query = `{
  collections(first: 2) {
    edges {
      node {
        id
        products(first: 5) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}`;

		// fetch url: https://jcstore-fi.myshopify.com/api/2021-01/graphql.json

		const params = {
			query: query
		}

		const options = {
			method: 'POST',
			headers: {
				'X-Shopify-Storefront-Access-Token': clientOptions.storefrontAccessToken,
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify(params)
		}

		const res = await fetch('https://jcstore-fi.myshopify.com/api/2021-01/graphql.json', options);
		const data = await res.json();

		console.log('data =>', data);
 */

		console.log('builderCollections =>', builderCollections);
		console.log('builderProducts =>', builderProducts);
		
		builderCollections.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
	
		// get products where productType equals 'dj-paketti'
		const djPakettiProducts = builderProducts.filter((product) => product.productType === 'dj-paketti');

		// add them to the first builderCollection.products
		builderCollections[0].products = djPakettiProducts;
		
		// add rest of the products to the second builderCollection.products
		builderCollections[1].products = builderProducts.filter((product) => product.productType !== 'dj-paketti');
	});

	/* Update selected products to be included in checkout */
	function updateSelection(event) {
		currentSelection[event.detail.step] = event.detail.products;
		console.log(`[step ${event.detail.step}]`, 'currentSelection =>', currentSelection);

		let tempPrice = 0;
		let tempHandles = [];
		currentSelection.forEach((step) => {
			for (const product of step) {
				tempPrice += parseFloat(product?.variants[0].price.amount || 0);
				tempHandles.push(product.handle);
			}
		});

		selectedHandles = tempHandles;
		priceTotal = tempPrice;
	};

	/* Update checkout notes value */
	function updateNotes(event) {
		checkoutNotes = event.detail.content;
	}

	function openDetailsModal(event) {
		if (modal.open === true) { return };
		modal.content = event.detail.content;
		modal.title = event.detail.title;
		modal.open = true;
		//document.body.classList.add('is-clipped');
	};

	function closeDetailsModal() {
		if (modal.open === false) { return };
		modal.open = false;
		//document.body.classList.remove('is-clipped');
	};

	async function generateCheckout() {
		if (checkoutProcessing === true) { return };
		checkoutProcessing = true;
		
		checkout = await client.checkout.create({
			note: checkoutNotes
		});

		const lineItemsToAdd = [];
		currentSelection.forEach((step) => {
			for (const product of step) {
				const variantId = product.variants[0].id;
				lineItemsToAdd.push({
					variantId: variantId,
					quantity: 1
				})
			}
		});

		await client.checkout.addLineItems(checkout.id, lineItemsToAdd);
		window.top.location.href = checkout.webUrl;
		
		setTimeout(() => {
			checkoutProcessing = false;
		}, 5000)
	};
</script>

<div class="modal {modal.open === true ? 'is-active' : ''}">
	<div class="modal-background"></div>
	<div class="modal-content">
		<div class="modal-card" use:clickOutside on:click_outside={closeDetailsModal}>
			<header class="modal-card-head">
				<p class="modal-card-title">
					{modal.title}
				</p>
				<button on:click={closeDetailsModal} class="delete" aria-label="close"></button>
			</header>
			<section class="modal-card-body">
				<div class="content">
				{@html modal.content}
				</div>
			</section>
		</div>
	</div>
</div>

<main class="container pt-5 px-5">
	{#if builderCollections}
		{#each builderCollections as builderCollection, indexOf}
			<!--{#if currentStep <= builderCollections.length}-->
				<BuilderCollectionSection selectedHandles={selectedHandles} currentSelection={currentSelection} on:viewDetails={openDetailsModal} on:selection={updateSelection} stepName="{builderCollections.title}" collection={builderCollection} stepNumber={indexOf + 1} maxSteps={builderCollections.length + 3} active={currentStep -1  === indexOf}/>
			<!--{/if}-->
		{/each}

		{#if currentStep == builderCollections.length + 1}
			<BuilderSection stepName="Tapahtuman tiedot" currentSelection={currentSelection} on:viewDetails={openDetailsModal} on:formSubmit={updateNotes} stepNumber={builderCollections.length + 1} maxSteps={builderCollections.length + 3} active={currentStep === builderCollections.length + 1 }/>
		{/if}

		{#if currentStep == builderCollections.length + 2}
			<BuilderSection stepName="Yhteenveto" currentSelection={currentSelection} on:viewDetails={openDetailsModal} on:selection={updateSelection} stepNumber={builderCollections.length + 2} maxSteps={builderCollections.length + 3} active={currentStep === builderCollections.length + 2 }/>
		{/if}

		<div class="pagination level">
			<div class="level-item is-narrow">
				{#if currentStep > 1}
					<button class="button is-black btn-back is-medium" on:click={() => currentStep--}>
						<span class="icon">
							<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
								<path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
							</svg>
						</span>
						<span>Takaisin</span>
					</button>
				{/if}
			</div>

			<div class="level-item has-text-centered">
				<span class="has-text-white">
					<small class="mr-1 has-text is-uppercase">Hinta alk.</small>
					<span class="has-text-weight-bold">
						{priceTotal} €
					</span>
				</span>
			</div>

			<div class="level-item is-narrow" style="justify-content: end;">
				{#if currentStep < builderCollections.length}
					<button class="button is-medium is-outlined btn-next" on:click={() => currentStep++}>
						<span>{builderCollections[currentStep].title.split(' | ').pop()}</span>
						<span class="icon">
							<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
								<path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
							</svg>
						</span>
					</button>
				{:else if currentStep == builderCollections.length}
					<button class="button is-medium is-outlined btn-next" on:click={() => currentStep++}>
						<span>Tapahtuman lisätiedot</span>
						<span class="icon">
							<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
								<path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
							</svg>
						</span>
					</button>
				{:else if currentStep == builderCollections.length + 1}
					{#if checkoutNotes !== false}
						<button class="button is-medium is-success btn-next" on:click={() => currentStep++}>
							Yhteenveto
						</button>
					{:else}
						<button class="button is-medium is-success btn-next" disabled>
							Yhteenveto
						</button>
					{/if}
				{:else if currentStep == builderCollections.length + 2}
					<button class="button is-medium is-outlined is-success btn-next {checkoutProcessing ? 'is-loading' : ''}" on:click={generateCheckout}>
						<span class="icon">
							<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
								<path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
							</svg>
						</span>
						<span>Siirry maksamaan</span>
					</button>
				{/if}
			</div>
		</div>
	{:else}
		<div class="loading-screen">
			<div class="dots-bars-3"></div>
		</div>
	{/if}
</main>

<style>
	.pagination {
		width: 100%;
		position: fixed;
		background: rgba(0,0,0,.8);
		backdrop-filter: saturate(180%) blur(20px);
		bottom: 0;
		left: 0;
		z-index: 1;
		padding: 15px;
	}

	@media only screen and (max-width: 768px) {
		.pagination {
			flex-direction: column;
		}
	}

	.dots-bars-3 {
  width: 40px;
  height: 26px;
  --c: linear-gradient(currentColor 0 0);
  background:
    var(--c) 0    100%,
    var(--c) 50%  100%,
    var(--c) 100% 100%;
  background-size:8px calc(100% - 4px);
  background-repeat: no-repeat;
  position: relative;
}
.dots-bars-3:before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background:currentColor;
  left:0;
  top:0;
  animation: 
    db3-1 1.5s  linear infinite alternate,
    db3-2 0.75s cubic-bezier(0,200,.8,200) infinite;
}


@keyframes db3-1 {
  100% {left:calc(100% - 8px)}
}

@keyframes db3-2 {
  100% {top:-0.1px}
}

.loading-screen {
	width: 100%;
	height: 100%;
	display: grid;
	place-content: center;
}
</style>